import axios from 'axios';

/*
*  This file contains all axios calls related to publish  on CB
*/

export const analyzeFunnelBeforePublishing = async (funnelId, funnelDraftXml) => {
    const response = await axios.post(`/app/funnel/${funnelId}/analyzeFunnelBeforePublishing`, { xml: funnelDraftXml });

    return response.data;
};

export const publish = async (
    funnelId,
    xml,
    newOrModifiedVertexIds,
    addContactsOnPublish,
    useReportToFilterContacts,
    dismissAddContactsModal,
) => {
    const payload = {
        xml,
        newOrModifiedVertexIds,
        addContactsOnPublish,
        useReportToFilterContacts,
        dismissAddContactsModal,
    };

    const { data } = await axios.put(`/app/funnel/${funnelId}/publish`, payload);

    return data;
};
